import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { Field, Form } from 'react-final-form';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { addError } from 'actions/index';
import { Button, translate, Checkbox } from '@haldor/ui';
import { getSchoolDataForSections } from 'actions/schools';
import api from 'lib/api';
import { getActiveSchool } from 'helpers/localstorage';

var SectionOptionForm = /*#__PURE__*/function (_Component) {
  _inherits(SectionOptionForm, _Component);

  var _super = _createSuper(SectionOptionForm);

  function SectionOptionForm() {
    var _this;

    _classCallCheck(this, SectionOptionForm);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "onSubmit", function (values) {
      return new Promise(function (resolve) {
        var translate = _this.props.translate;
        var activeSchool = getActiveSchool(_this.props.currentUser.id);
        var data = [];
        Object.keys(values).forEach(function (key) {
          if (key == 'schoolId') {
            return false;
          }

          data.push({
            'Key': key,
            'Value': values[key]
          });
        });
        api.put('schools/schooldata', data).then(function () {
          resolve(1);

          _this.props.getSchoolDataForSections(activeSchool).then(function () {
            _this.props.onAbort(true);

            _this.props.addError(translate('changes-saved'), 'info');
          });
        })["catch"](function () {
          resolve(1);

          _this.props.addError(translate('Something went wrong while saving the options'), 'error');
        });
      });
    });

    return _this;
  }

  _createClass(SectionOptionForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: '0 1.75rem'
        }
      }, /*#__PURE__*/React.createElement(Form, {
        initialValues: this.props.allowManualConnection,
        onSubmit: this.onSubmit,
        render: function render(_ref) {
          var submitting = _ref.submitting,
              handleSubmit = _ref.handleSubmit,
              pristine = _ref.pristine;
          return /*#__PURE__*/React.createElement("form", {
            className: "form form-component",
            onSubmit: handleSubmit
          }, submitting ? /*#__PURE__*/React.createElement("div", {
            className: "is_sending"
          }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
            className: "loading-spinner"
          }))) : null, /*#__PURE__*/React.createElement("div", {
            className: "modal-content"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('Allow manual connection of Groups')), /*#__PURE__*/React.createElement("div", {
            style: {
              marginTop: '1rem'
            }
          }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Field, {
            component: Checkbox,
            name: "allowManualMentorGroupConnection",
            label: _this2.props.translate("Mentor groups")
          })), /*#__PURE__*/React.createElement("div", {
            style: {
              marginTop: '.35rem'
            }
          }, /*#__PURE__*/React.createElement(Field, {
            component: Checkbox,
            name: "allowManualEducationGroupConnection",
            label: _this2.props.translate("Education groups")
          })))), /*#__PURE__*/React.createElement("div", {
            style: {
              marginTop: '3rem'
            },
            className: "df aic jcb"
          }, /*#__PURE__*/React.createElement(Button, {
            disabled: submitting || pristine
          }, _this2.props.translate('save')), /*#__PURE__*/React.createElement("div", {
            className: "align-right"
          }, /*#__PURE__*/React.createElement(Button, {
            onClick: function onClick(event) {
              event.preventDefault();

              _this2.props.onAbort(false);
            },
            type: "secondary"
          }, _this2.props.translate('Cancel')))));
        }
      })));
    }
  }]);

  return SectionOptionForm;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser
  };
};

export default withRouter(connect(mapStateToProps, {
  addError: addError,
  getSchoolDataForSections: getSchoolDataForSections
})(SectionOptionForm));